import { Entity } from '@backstage/catalog-model';
import { K8S_ENVIRONMENT_ANNOTATIONS } from '../types';

/**
 * 判断 System 是否为 K8s 原生管理模式
 * 检测 hose.io/powered-by 注解是否为 "kubernetes"
 */
export function isK8sManagedSystem(entity: Entity): boolean {
  return (
    entity.metadata.annotations?.[K8S_ENVIRONMENT_ANNOTATIONS.POWERED_BY] === 'kubernetes'
  );
}
